export const webConfig = {
  appName: '桃花里',
  logoUrl: 'https://thl-data.hi3oss.ctyunxs.cn/webResource/logo/tao_logo.png',
  logoUrlAlpha: 'https://thl-data.hi3oss.ctyunxs.cn/webResource/logo/tao_logo_alpha.png'
}